import PurchasedGiftItem from './PurchasedGiftItem';

export default PurchasedGiftItem;
